import './styles/index.scss';
import DefaultLoadingScreen from './DefaultLoadingScreen';
import { WillyWonkaTitleIcon } from './WillyWonkaTitleIcon';
import {
  resolveLoadingTheme,
  shouldShowLoadingSkin,
} from './helpers/loadingThemeMap';

const LoadingScreen = ({
  themeData,
  setLoadingAnimationFinished,
  isStuckedLoading,
  orientation,
  isAndroid = false,
  type,
}) => {
  const localTheme = themeData?.data?.body?.[0]?.items?.[0];
  const { themeName, themeClasses } = resolveLoadingTheme(
    themeData?.data?.loading_theme,
  );
  const isWillyWonka = themeName === 'willy_wonka';
  const hasBottomBanner = !!localTheme?.is_bottom_banner;

  const backgroundLandscapeUrl = localTheme?.background_landscape?.url;
  const hasSkin = shouldShowLoadingSkin({
    backgroundLandscapeUrl,
    oompaLoompaUrl: localTheme?.oompa_loompa?.url,
    themeName,
    isAndroid,
  });

  const hasThemedIcon = Boolean(localTheme?.icon?.url);
  const isAndroidLandscapeWithBanner =
    isAndroid && orientation === 'landscape' && hasBottomBanner;

  const useOverlayLayout = hasSkin && isWillyWonka && !hasBottomBanner;
  const showCustomIcon =
    useOverlayLayout && hasThemedIcon && Boolean(localTheme?.icon?.url);

  const skinLayoutClass = hasBottomBanner ? 'bottom' : 'full';
  const skinModifierClasses = themeClasses
    .filter((themeClass) => themeClass !== 'full' && themeClass !== 'bottom')
    .join(' ');

  return (
    <>
      {hasSkin && (
        <div
          className={`loading-screen willy_wonka ${skinLayoutClass} ${skinModifierClasses} cover`}
          style={{
            backgroundImage: `url(${backgroundLandscapeUrl})`,
          }}
        >
          {showCustomIcon && (
            <div className="loading-screen__skin-logo" aria-hidden>
              <WillyWonkaTitleIcon url={localTheme.icon.url} />
            </div>
          )}
          {localTheme?.oompa_loompa?.url && (
            <div className="oompa-loompa-container">
              <img src={localTheme?.oompa_loompa?.url} alt="oompa-loompa" />
            </div>
          )}
        </div>
      )}
      <div
        className={`loading-container ${useOverlayLayout ? 'overlay' : 'default'} ${orientation} ${type} ${hasBottomBanner ? 'withBottomBanner' : ''} ${isAndroidLandscapeWithBanner ? 'android-landscape-banner' : ''}`}
      >
        <DefaultLoadingScreen
          type={type}
          onAnimationFinish={() => setLoadingAnimationFinished(true)}
          isStuckedLoading={isStuckedLoading}
          isLandscapeMobile={orientation}
          isDefault={!useOverlayLayout}
          isBottomBanner={localTheme?.is_bottom}
        />
      </div>
    </>
  );
};

export default LoadingScreen;
